var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-footer"},[_c('el-divider'),_c('span',[_vm._v("©2023 windsong")]),_c('span',[_vm._v("仅供个人学习使用，切勿用作其他用途")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }